// extracted by mini-css-extract-plugin
export default {"wrapper":"footer-module--wrapper--3d244","nav":"footer-module--nav--7a0cd"};